import { Bar } from 'react-chartjs-2';
import { round, baseBarOptions, CHART_COLORS } from '../../../config/chart-config';

const FatChart = ({ labels, values }) => {
    if (!values?.length) return null;

    const backgroundColors = labels.map((label) => {
        const lower = label.toLowerCase();
        if (lower.includes('enkel')) return CHART_COLORS.yellow;
        if (lower.includes('fler')) return CHART_COLORS.red;
        return CHART_COLORS.blue;
    });

    const data = {
        labels,
        datasets: [
            {
                label: 'gram',
                data: values.map(round),
                backgroundColor: backgroundColors
            }
        ]
    };

    const options = {
        ...baseBarOptions,
        scales: {
            ...baseBarOptions.scales,
            y: {
                ...baseBarOptions.scales.y,
                title: { display: true, text: 'gram' }
            }
        }
    };

    return (
        <div className="chart-wrapper">
            <span>Fett</span>
            <div className="chart-inner">
                <Bar data={data} options={options} />
            </div>
        </div>
    );
};

export default FatChart;
